var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsertRowButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0961 0.906883V22.6721H6.40214V0.906883H31.0961ZM31.0961 0H6.40214C6.28204 -3.02386e-09 6.1631 0.0234572 6.05214 0.0690323C5.94118 0.114607 5.84035 0.181408 5.75543 0.26562C5.6705 0.349832 5.60313 0.449806 5.55717 0.559834C5.51121 0.669862 5.48755 0.787789 5.48755 0.906883V22.6721C5.48755 22.7912 5.51121 22.9091 5.55717 23.0191C5.60313 23.1291 5.6705 23.2291 5.75543 23.3133C5.84035 23.3975 5.94118 23.4643 6.05214 23.5099C6.1631 23.5555 6.28204 23.5789 6.40214 23.5789H31.0961C31.3387 23.5789 31.5713 23.4834 31.7428 23.3133C31.9144 23.1433 32.0107 22.9126 32.0107 22.6721V0.906883C32.0107 0.666362 31.9144 0.435693 31.7428 0.26562C31.5713 0.0955463 31.3387 0 31.0961 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40213 9.06884H31.0961V9.97572H6.40213V9.06884ZM6.40213 13.6032H31.0961V14.5101H6.40213V13.6032ZM6.40213 18.1377H31.0961V19.0445H6.40213V18.1377ZM6.40213 4.53442H31.0961V5.44131H6.40213V4.53442Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8043 0.90686V22.672H11.8897V0.90686H12.8043ZM19.2064 0.90686V22.672H18.2919V0.90686H19.2064ZM25.6086 0.90686V22.672H24.694V0.90686H25.6086Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40215 4.98792H31.0961C31.401 4.98792 31.5534 5.13906 31.5534 5.44136V9.06889C31.5534 9.37118 31.401 9.52233 31.0961 9.52233H6.40215C6.09729 9.52233 5.94485 9.37118 5.94485 9.06889V5.44136C5.94485 5.13906 6.09729 4.98792 6.40215 4.98792Z",
    fill: "#66A35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0961 5.44131V9.06884H6.40214V5.44131H31.0961ZM31.0961 4.53442H6.40214C6.28204 4.53442 6.1631 4.55788 6.05214 4.60346C5.94118 4.64903 5.84035 4.71583 5.75543 4.80004C5.6705 4.88426 5.60313 4.98423 5.55717 5.09426C5.51121 5.20429 5.48755 5.32221 5.48755 5.44131V9.06884C5.48755 9.18793 5.51121 9.30586 5.55717 9.41589C5.60313 9.52591 5.6705 9.62589 5.75543 9.7101C5.84035 9.79431 5.94118 9.86111 6.05214 9.90669C6.1631 9.95226 6.28204 9.97572 6.40214 9.97572H31.0961C31.3387 9.97572 31.5713 9.88017 31.7428 9.7101C31.9144 9.54003 32.0107 9.30936 32.0107 9.06884V5.44131C32.0107 5.20079 31.9144 4.97012 31.7428 4.80004C31.5713 4.62997 31.3387 4.53442 31.0961 4.53442Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57297 7.25507L1.82919 4.53442V9.97572L4.57297 7.25507Z",
    fill: "#66A35C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.82918 6.38442V8.12563C1.82918 8.14982 1.81699 8.16191 1.7926 8.16191H0.0365837C0.0121946 8.16191 0 8.14982 0 8.12563V6.38442C0 6.36024 0.0121946 6.34814 0.0365837 6.34814H1.7926C1.81699 6.34814 1.82918 6.36024 1.82918 6.38442Z",
    fill: "#66A35C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_79"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 23.5789,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertRowButton);
export default __webpack_public_path__ + "static/media/InsertRowButton.546fa1919d533354264bed54cb9c7d93.svg";
export { ForwardRef as ReactComponent };